module.exports = __webpack_public_path__ + "static/media/ic_nav_06_selected.94bc6705.svg";